import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FilesService } from './files.service';

@Component({
  selector: 'convfact-files-repair-dialog',
  templateUrl: './files-dialog-repair.component.html',
  styleUrls: ['./files-dialog-repair.component.css'],
  standalone: false
})
export class FilesDialogRepairComponent {

  scope: 'user' | 'all' = 'user';

  userUid: string = '';
  loading = false;
  error: string = null;

  result: {
    mode: string;
    totalFiles: number;
    repairedCount: number;
    ambiguousCount: number;
    missingCount: number;
    repaired: any[];
    ambiguous: any[];
    missing: any[];
  } = null;

  resultAll: {
    mode: string;
    usersChecked: number;
    usersWithIssuesCount: number;
    usersWithIssues: any[];
  } = null;

  constructor(
    private dialogRef: MatDialogRef<FilesDialogRepairComponent>,
    private filesService: FilesService
  ) { }

  setScope(scope: 'user' | 'all'): void {
    this.scope = scope;
    this.error = null;
    this.result = null;
    this.resultAll = null;
  }

  analyze(): void {
    this.run(false);
  }

  apply(): void {
    this.run(true);
  }

  private run(apply: boolean): void {
    if (this.scope === 'user') {
      if (!this.userUid || !this.userUid.trim()) {
        this.error = 'Indica el UID del usuario a comprobar';
        return;
      }

      this.error = null;
      this.loading = true;
      this.result = null;

      this.filesService.repairStorage(this.userUid.trim(), apply)
        .then(res => {
          const data = res && res.data ? res.data : res;

          if (!data) {
            console.warn('Respuesta inesperada de repair-storage:', res);
          }

          this.result = {
            mode: data ? data.mode : null,
            totalFiles: data ? data.totalFiles : 0,
            repairedCount: data ? data.repairedCount : 0,
            ambiguousCount: data ? data.ambiguousCount : 0,
            missingCount: data ? data.missingCount : 0,
            repaired: (data && Array.isArray(data.repaired)) ? data.repaired : [],
            ambiguous: (data && Array.isArray(data.ambiguous)) ? data.ambiguous : [],
            missing: (data && Array.isArray(data.missing)) ? data.missing : []
          };
        })
        .catch(err => {
          this.error = (err && err.error && err.error.message)
            ? err.error.message
            : 'Ha ocurrido un error al comprobar el almacenamiento';
        })
        .finally(() => this.loading = false);

    } else {
      this.error = null;
      this.loading = true;
      this.resultAll = null;

      this.filesService.repairStorageAll(apply)
        .then(res => {
          const data = res && res.data ? res.data : res;

          if (!data || !Array.isArray(data.usersWithIssues)) {
            console.warn('Respuesta inesperada de repair-storage-all:', res);
          }

          this.resultAll = {
            mode: data ? data.mode : null,
            usersChecked: data ? data.usersChecked : 0,
            usersWithIssuesCount: data ? data.usersWithIssuesCount : 0,
            usersWithIssues: (data && Array.isArray(data.usersWithIssues)) ? data.usersWithIssues : []
          };
        })
        .catch(err => {
          this.error = (err && err.error && err.error.message)
            ? err.error.message
            : 'Ha ocurrido un error al comprobar el almacenamiento';
        })
        .finally(() => this.loading = false);
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
